import { Column, Columns, Span, Tag, Tags } from "trunx";
import {
  decimalPlaces,
  formatUnit,
  useLocaleContext,
} from "../../contexts/LocaleContext";

import { observer } from "mobx-react-lite";
import { splitEvery } from "ramda";
import convert  from "../../convert";
import { ISelectedStreamSensor } from "../../models/SelectedSensor";
import { streamPeriods } from "../../shared/streamPeriods";

const StreamDataTable = ({ selected }: { selected: ISelectedStreamSensor }) => {
  const { sensor, display } = selected;
  const {
    dict: { intervals: dict },
  } = useLocaleContext();

  const {
    dict: {
      panel: {
        sensors: {
          info: { stage: stageTitle, discharge: dischargeTitle },
        },
      },
    },

    units: {
      stream: { stage: toHeightUnit, discharge: toDischargeUnit },
    },
  } = useLocaleContext();

  const title = display.measure === "stage" ? stageTitle : dischargeTitle;
  const measure = display.measure === "stage" ? sensor.stage : sensor.discharge;

  if (!measure) {
    return <></>;
  }

  const fromUnit = measure.unit;
  const toUnit = display.measure === "stage" ? toHeightUnit : toDischargeUnit;

  interface DataTagProps {
    period: string;
    value: number | undefined;
  }

  let data: DataTagProps[] = [];

  if (measure.latest !== null) {
    data.push({ period: "latest", value: measure.latest.value });
  }
  for (const period of streamPeriods) {
    const value = measure.max.get(period)?.value;
    data.push({ period, value });
  }

  const DataTag = observer(({ period, value }: DataTagProps) => {
    const isDisplaying = period === display.period;

    const label =
      period === "latest" ? dict.lastLabel : dict.durationLabel[period];

    return (
      <Tags
        className="is-stage is-justify-content-center"
        key={period}
        hasAddons
      >
        <Tag key="label" bulma={isDisplaying ? ["is-info"] : []}>
          {label}
        </Tag>
        <Tag key="value" bulma={value !== 0 ? ["is-primary"] : []}>
          {value !== undefined && fromUnit
            ? convert(value)
                .from(fromUnit)
                .to(toUnit)
                .toFixed(decimalPlaces(toUnit))
            : ""}
        </Tag>
      </Tags>
    );
  });

  interface DataColumnProps {
    data: DataTagProps[];
    idx: number;
  }
  const DataColumn = ({ data, idx }: DataColumnProps) => (
    <Column key={idx.toString()}>
      {data.map((d, idx_) => (
        <DataTag key={idx_} {...d} />
      ))}
    </Column>
  );

  return (
    <div id="sensor-data-table">
      <p className="subtitle">
        {title}&nbsp;
        <Span bulma="is-size-6">({formatUnit(toUnit)})</Span>
      </p>

      <Columns bulma="is-mobile">
        {splitEvery(2, data).map((column, idx) => (
          <DataColumn key={idx} idx={idx} data={column} />
        ))}
      </Columns>
    </div>
  );
};

export default observer(StreamDataTable);
